import apiInstance from '@apis/index';
import { IRentalPropertyQuery } from 'interface/RentalProperty';

export enum RentalPropertyPath {
  DEFAULT = 'rental-properties',
  DETAIL = 'rental-properties/:id',
  AVAILABLE_QUANTITY_FOR_MONTH = '/rental-properties/:id/available-quantity/month',
}

export const getRentalPropertyList = async (payload?: IRentalPropertyQuery) => {
  return apiInstance.get(RentalPropertyPath.DEFAULT, {
    params: {
      ...payload,
    },
  });
};

export const getRentalPropertyDetail = async (id: string) => {
  return apiInstance.get(RentalPropertyPath.DETAIL.replace(':id', id));
};

export const getBookingQuantityAvailableForMonth = async (
  id: string,
  year: number,
  month: number,
) => {
  return apiInstance.get(
    RentalPropertyPath.AVAILABLE_QUANTITY_FOR_MONTH.replace(':id', id),
    {
      params: {
        year,
        month,
      },
    },
  );
};
